import { render, staticRenderFns } from "./mypatients.vue?vue&type=template&id=d2af4a42&scoped=true"
import script from "./mypatients.vue?vue&type=script&lang=js"
export * from "./mypatients.vue?vue&type=script&lang=js"
import style0 from "./mypatients.vue?vue&type=style&index=0&id=d2af4a42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2af4a42",
  null
  
)

export default component.exports